import React from 'react';

const ConsultIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="12" viewBox="0 0 16 12">
      <g transform="translate(0.5 0.5)">
        <path d="M5.3,6.689,0,1.291A2.609,2.609,0,0,1,2.3,0h9.744a2.707,2.707,0,0,1,1.807.669A2.235,2.235,0,0,1,14.5,1.681C12.66,3.4,9.183,6.358,9.183,6.358a3.033,3.033,0,0,1-2.19.977A2.479,2.479,0,0,1,5.3,6.689Z" transform="translate(0.26 0)" fill="none" stroke="currentColor" strokeWidth="1"/>
        <path d="M12.3,1H2.555A2.447,2.447,0,0,0,0,3.287V9.653a2.447,2.447,0,0,0,2.555,2.288H12.3A2.446,2.446,0,0,0,14.85,9.653V3.287a2.164,2.164,0,0,0-.744-1.619A2.705,2.705,0,0,0,12.3,1Z" transform="translate(0 -1)" fill="none" stroke="currentColor" strokeWidth="1"/>
      </g>
    </svg>

  );
};

export default ConsultIcon;
